<mat-card class="team-card" matRipple (click)="onSelect()" (keydown.enter)="onSelect()" (keydown.space)="$event.preventDefault(); onSelect()" tabindex="0" role="button">
  <mat-card-content class="team-card__content">
    <app-team-icon [teamId]="team.identification"></app-team-icon>
    <div class="team-card__details">
      <span class="team-card__name body-medium">{{ team.name }}</span>
      @if (team.description) {
        <span class="team-card__description body-medium">{{ team.description }}</span>
      }
    </div>
    @if (team.unassignedCaseCount) {
      <span
        class="team-card__badge"
        [matBadge]="team.unassignedCaseCount"
        matBadgeColor="warn"
      [matTooltip]="(team.unassignedCaseCount === 1 ? 'teamSelection.badges.unassignedCase' : 'teamSelection.badges.unassignedCases') | translate:{count: team.unassignedCaseCount}"></span>
    }
  </mat-card-content>
</mat-card>
